var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "package-bg.svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 370,
    height: 207,
    viewBox: "0 0 370 207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #cacfec;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-1 {\n        filter: url(#filter);\n      }\n\n      .cls-2 {\n        filter: url(#filter-2);\n      }\n\n      .cls-3 {\n        fill: #f5faff;\n        opacity: 0.5;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: 375,
    y: 1898,
    width: 370,
    height: 205.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    preserveAspectRatio: "none",
    x: 375,
    y: 1898,
    width: 370,
    height: 205.5,
    result: "image",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzcwIiBoZWlnaHQ9IjIwNS41IiB2aWV3Qm94PSIwIDAgMzcwIDIwNS41Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiB1cmwoI2xpbmVhci1ncmFkaWVudCk7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeTE9IjEwMi43NSIgeDI9IjM3MCIgeTI9IjEwMi43NSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMwNjllYmYiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDRkOGQ2Ii8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSIzNzAiIGhlaWdodD0iMjA1LjUiLz4KPC9zdmc+Cg=="
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    mode: "multiply",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    x: 375,
    y: 1898,
    width: 370,
    height: 206,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    preserveAspectRatio: "none",
    x: 375,
    y: 1898,
    width: 370,
    height: 206,
    result: "image",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzcwIiBoZWlnaHQ9IjIwNiIgdmlld0JveD0iMCAwIDM3MCAyMDYiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IHVybCgjbGluZWFyLWdyYWRpZW50KTsKICAgICAgfQogICAgPC9zdHlsZT4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB5MT0iMTAzIiB4Mj0iMzcwIiB5Mj0iMTAzIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzA2OWViZiIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwNGQ4ZDYiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjM3MCIgaGVpZ2h0PSIyMDYiLz4KPC9zdmc+Cg=="
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    mode: "multiply",
    in2: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Top",
    className: "cls-1",
    d: "M384.25,1898h351.5a9.272,9.272,0,0,1,9.25,9.3v196.2s-85.691-4.14-167.425-51.14c-134.1-77.13-202.575-9.3-202.575-9.3V1907.3A9.272,9.272,0,0,1,384.25,1898Z",
    transform: "translate(-375 -1898)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Top-2",
    "data-name": "Top",
    className: "cls-2",
    d: "M735.75,1898H384.25a9.283,9.283,0,0,0-9.25,9.32V2104s85.691-4.15,167.425-51.27c134.1-77.31,202.575-9.32,202.575-9.32V1907.32A9.283,9.283,0,0,0,735.75,1898Z",
    transform: "translate(-375 -1898)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Left_Shape",
    "data-name": "Left Shape",
    className: "cls-3",
    d: "M375,2043s66.812-58.71,185,1c0,0-83.64,54.41-185,61v-62Z",
    transform: "translate(-375 -1898)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Right_Shape",
    "data-name": "Right Shape",
    className: "cls-3",
    d: "M745,2041.87s-66.812-58.84-185,1c0,0,83.64,54.53,185,61.13",
    transform: "translate(-375 -1898)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP1);
export default __webpack_public_path__ + "static/media/p1.01e615a28de5c98441465107e71fd264.svg";
export { ForwardRef as ReactComponent };